import {
  EigenschaftType,
  EinzelleistungDruck,
  FachschluesselTyp,
  KategorieID,
  SpartenType,
  SummenWerte,
  ZusatzFeature as BffZusatzFeature,
} from '@ps20/bff-models';
import { Produktlinie } from './produktlinie';
import { ZusatzoptionItem } from './zusatzoptionenItem';
import { IPriceable } from './iPriceable';

export type Eigenschaft = string | VersicherungssummenEigenschaft | WertsachensummenEigenschaft;

export interface VersicherungssummenEigenschaft {
  type: EigenschaftType.VERSICHERUNGSSUMME;
  faktor?: number;
  maxSumme?: number;
  showUnterversicherung?: boolean;
}

export interface WertsachensummenEigenschaft {
  type: EigenschaftType.WERTSACHENSUMME;
}

export interface Leistung extends IPriceable {
  id: string;
  label: string;
  info?: string;
  eigenschaft?: Eigenschaft;
  eigenschaftInfo?: string;
  fachschluessel?: string;
  hidden?: boolean;
  isWeitereLeistung?: boolean;
  reihenfolge: number;
  fachschluesselTyp?: FachschluesselTyp;
  writeToEinreichenXML: boolean;
  summenBezeichnung?: string;
  summe?: string;
  summenWerte?: SummenWerte;
  zusatzFeature?: ZusatzFeature;
  kategorie?: string;
  kategorieId?: KategorieID;
  abgewaehlt?: boolean;
  gefahrId?: string;
}

export interface UnfallLeistung extends Leistung {
  nettopreisProJahr: ZusatzoptionItem['bruttopreis'];
  bruttopreis: ZusatzoptionItem['bruttopreis'];
}

export enum LeistungEigenschaft {
  INKLUSIVE = 'Inklusive',
  EXKLUSIVE = 'Nicht enthalten',
  UNBEGRENZT = 'Unbegrenzt',
}

export enum ZusatzFeature {
  NEBENGEBAEUDE = 'NEBENGEBAEUDE',
  SELBSTBEHALT = 'SELBSTBEHALT',
  HAUPTGEBAEUDE = 'HAUPTGEBAEUDE',
}

export function convertToZusatzFeature(bffZusatzFeature: BffZusatzFeature): ZusatzFeature {
  const zusatzFeature = {
    [BffZusatzFeature.HAUPTGEBAEUDE]: ZusatzFeature.HAUPTGEBAEUDE,
    [BffZusatzFeature.NEBENGEBAEUDE]: ZusatzFeature.NEBENGEBAEUDE,
    [BffZusatzFeature.SELBSTBEHALT]: ZusatzFeature.SELBSTBEHALT,
  }[bffZusatzFeature];
  if (zusatzFeature) {
    return zusatzFeature;
  } else {
    throw new Error('Following BffZusatzFeature could not be mapped: ' + bffZusatzFeature);
  }
}

export function mapLeistungen(
  ausgewaehlteProduktlinie: Produktlinie,
  spartenType?: SpartenType,
  versicherungssumme?: number,
  regExpForSumme?: string,
): Array<EinzelleistungDruck> {
  return (
    ausgewaehlteProduktlinie?.leistungen &&
    ausgewaehlteProduktlinie.leistungen
      .filter(leistung => !leistung.abgewaehlt)
      .map(leistung => {
        const einzelleistungDruck: EinzelleistungDruck = {
          id: leistung.id,
          versicherungssumme,
          produktLinie: ausgewaehlteProduktlinie.produktName,
          spartenType,
          kurztext: ausgewaehlteProduktlinie.kurztext,
        };
        if (
          typeof leistung?.eigenschaft === 'string' &&
          regExpForSumme &&
          new RegExp(regExpForSumme).exec(leistung.eigenschaft)
        ) {
          einzelleistungDruck.eigenschaft = leistung.eigenschaft;
        }
        return einzelleistungDruck;
      })
  );
}
